<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-if="this.$store.getters.isLoggedIn">
        <SummaryView/>        
      </v-col>
      <v-col cols="12" v-else>
        <LoginPrompt />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SummaryView from "@/components/SummaryView";
import LoginPrompt from "@/components/LoginPrompt";

export default {
  components: {
    SummaryView,
    LoginPrompt,
  },
};
</script>